import React from 'react';

function render_empty() {
	return (
		<p className="transcription-empty">
			No transcriptions yet. Click Start to begin.
		</p>
	);
}

function render_item(text, index) {
	return (
		<li key={index} className="transcription-item">
			<span className="transcription-index">{index + 1}</span>
			<span className="transcription-text">{text}</span>
		</li>
	);
}

function render_list(transcriptions) {
	return (
		<ul className="transcription-list">
			{transcriptions.map(function(text, index) {
				return render_item(text, index);
			})}
		</ul>
	);
}

function TranscriptionList({ transcriptions }) {
	if(transcriptions.length === 0) {
		return render_empty();
	}
	return render_list(transcriptions);
}

export default TranscriptionList;
